import {
  IconAnalytics,
  IconBell,
  IconBinocularsGray,
  IconCar,
  IconChainLink,
  IconChartBar,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconLayers,
  IconLocation,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconShareGray,
  IconTagGray,
  IconTvocGray,
  IconWarning,
  IconZoneGray,
} from '@assets/images/icon';
import { rtlsSystem } from '@assets/images/solution';
import mainVideo from '@src/assets/images/solution/constructionSafety/video/rtlsVideo.mp4';

import image1 from '@src/assets/images/solution/publicSafety/img/1.avif';
import function1 from '@src/assets/images/solution/publicSafety/img/function1.avif';
import function2 from '@src/assets/images/solution/publicSafety/img/function2.avif';
import function3 from '@src/assets/images/solution/publicSafety/img/function3.avif';
import function4 from '@src/assets/images/solution/publicSafety/img/function4.avif';
import image3 from '@src/assets/images/solution/publicSafety/img/3.avif';
import image4 from '@src/assets/images/solution/publicSafety/img/4.avif';
import image5 from '@src/assets/images/solution/publicSafety/img/5.avif';
import image6 from '@src/assets/images/solution/publicSafety/img/6.avif';
import image7 from '@src/assets/images/solution/publicSafety/img/7.avif';
import image8 from '@src/assets/images/solution/publicSafety/img/8.avif';
import image9 from '@src/assets/images/solution/publicSafety/img/9.avif';
import image10 from '@src/assets/images/solution/publicSafety/img/10.avif';

import customer1 from '@src/assets/images/solution/publicSafety/img/customer1.png';
import { publicSafety1, publicSafety2 } from '@assets/images/solution/recommendation';
import recommendation from '../common/recommendation';

export default {
  type: '도시 안전 솔루션',

  recommend: {
    title: '버튼형 기기를 설치해 시민의 긴급 상황을 자동으로 신고합니다',
    desc: '건물 외벽이나 기둥에 설치된 무선 안심벨 장비는 버튼 입력 시 112와 보호자에게 동시에 경고 알림을 전송합니다',
    labels: {
      desktop: [
        {
          img: publicSafety1,
          data: recommendation.loraGateway,
        },
        {
          img: publicSafety2,
          data: recommendation.safetyBell,
        },
      ],
      mobile: [
        {
          data: recommendation.safetyBell,
        },
        {
          data: recommendation.loraGateway,
        },
        {
          data: recommendation.server,
        },
      ],
    },
  },

  banner: {
    title: '위급 상황에 버튼 하나로 신고하고 골든타임을 확보하세요',
    desc: '안심벨을 통해 시민의 신고 위치를 자동으로 전송하고 보호자와 지자체에 긴급 알림을 동시에 전달합니다',
  },

  summary: {
    title: '도시 전체를 한눈에 관리할 수 있는 모니터링 시스템을 구축하세요.',
    desc: '',
    function: {
      card: [
        {
          image: function1,
          title: '실시간 운영 지표를 한눈에 파악하는 대시보드',
          desc: '신고 건수, 신청 수, 사용 비율, 연령 및 지역 분포 등 핵심 지표를 실시간으로 종합 분석할 수 있습니다. 전체 상황을 빠르게 파악하고 주요 변동 흐름을 놓치지 않도록 설계되어, 도시 단위의 의사결정이 효율적으로 이뤄집니다.',
        },
        {
          image: function2,
          title: '신청 유형별 수요 흐름 분석',
          desc: '1인 가구, 점포, 시설 등 신청 유형별 비율을 날짜별로 추적하면서 수요의 흐름을 분석할 수 있습니다. 특정 유형이 언제 집중되는지, 시간대별 변화가 어떻게 나타나는지를 정밀하게 파악할 수 있어, 정책 타이밍이나 설치 시점을 전략적으로 계획할 수 있습니다.',
        },
        {
          image: function3,
          title: '지역별 운영 데이터를 기반으로 공간 전략 수립',
          desc: '안심벨 신청자 수, 등록 완료자 수, 실제 신고 발생 인원까지 지역별로 세분화해 비교할 수 있습니다. 단순 보급 수치가 아니라 실제 사용률과 신고 빈도를 함께 분석함으로써, 각 지역의 위험 특성이나 수요 패턴을 파악하고 우선 대응이 필요한 구역을 전략적으로 설정할 수 있습니다.',
        },
        {
          image: function4,
          title: '배송부터 설치까지 전 과정을 추적',
          desc: '신청 접수부터 배송, 수령, 설치 완료까지 모든 단계가 시스템에 기록됩니다. 누락이나 지연 여부를 실시간으로 확인하고, 민원 대응과 운영 안정성을 높일 수 있습니다.',
        },
      ],
    },
  },

  numOfCard: {
    title: '실제 사용을 입증하는 운영 지표',
    desc: '신청부터 설치, 신고까지 실제 현장에서 어떻게 작동하고 있는지 수치로 증명합니다.',
    card: [
      {
        tag: '21,480명',
        title: '누적 신청 수',
        desc: '안심벨 보급 이후 누적 사용자수',
      },
      {
        tag: '96.7%',
        title: '등록 완료율',
        desc: '기기 수령 후 앱 등록 완료 기준',
      },
      {
        tag: '62%',
        title: '테스트 버튼 주기적 사용률',
        desc: '분기당 1회 이상 테스트 수행',
      },
    ],
  },

  func: [
    {
      theme: '작지만 똑똑한 호출 기기를 구축하세요.',
      title: '긴급 상황에서 즉시 대응할 수 있는 신고 기능',
      desc: '버튼을 누르면 112에 자동으로 연결되고, 보호자나 지인에게도 문자 알림이 전송됩니다. 스마트폰이 없거나 조작이 어려운 상황에서도 신속하게 대응할 수 있어, 실제 환경에서 안정적인 활용이 가능합니다.',
      sub1: '높은 정확도 제공',
      icon1: IconRulerGray,
      sub2: '실시간 현황 파악',
      icon2: IconClockGray,
      image: image3,
    },
    {
      title: '벽, 기둥 등 다양한 공간에 설치 가능',
      desc: '기기는 벽면, 기둥, 출입문 근처 등 다양한 고정 구조물에 손쉽게 설치할 수 있도록 설계되었습니다. 실내외 공간에 자연스럽게 부착할 수 있으며, 별도 전원이나 복잡한 시공 없이 빠르게 설치할 수 있습니다.',
      sub2: '실시간 위치 추적',
      icon1: IconBinocularsGray,
      sub1: '빠른 데이터 연동',
      icon2: IconTvocGray,
      image: image4,
    },
    {
      title: '상시 점검 가능한 연결 테스트 기능',
      desc: '연결 상태를 직접 확인할 수 있는 테스트 버튼이 내장돼 있어, 작동 여부를 일상적으로 점검할 수 있습니다. 사용자와 운영자 모두 기기 상태를 사전에 확인할 수 있어 운영 안정성이 높아집니다.',
      sub1: '실시간 위치 추적',
      icon1: IconBinocularsGray,
      sub2: '높은 정확도 제공',
      icon2: IconRulerGray,
      image: image5,
    },
    {
      title: '장기간 사용할 수 있는 저전력 설계',
      desc: '배터리 교체나 충전 없이 10년 이상 사용할 수 있도록 초저전력 회로로 설계되었습니다. 유지관리 부담을 최소화하면서도 장기적인 안정성을 확보할 수 있습니다.',
      sub1: '자유로운 범위 설정',
      icon1: IconZoneGray,
      sub2: '여러 구역 설정',
      icon2: IconTagGray,
      image: image6,
    },
    {
      theme: '안심벨 앱으로 운영을 효율화하고 알림 대응력을 높이세요.',
      title: '신고 접수와 취소를 실시간으로 확인',
      desc: '앱을 통해 안심벨의 신고가 정상적으로 접수되었는지 즉시 확인할 수 있으며, 잘못된 신고는 2분 내 취소할 수 있도록 설정되어 있습니다. 실시간 확인과 제어가 가능해 오작동이나 오신고에 유연하게 대응할 수 있습니다.',
      sub1: '자유로운 범위 설정',
      icon1: IconZoneGray,
      sub2: '여러 구역 설정',
      icon2: IconTagGray,
      image: image7,
    },
    {
      title: '신고 수신 대상을 자유롭게 지정',
      desc: '신고가 발생하면 112는 물론, 보호자나 지인 등 원하는 수신 대상을 동시에 지정할 수 있습니다. 하나의 신고로 여러 명에게 알림을 동시에 전송할 수 있어, 공공 대응과 개인 보호를 함께 지원할 수 있습니다.',
      sub1: '자유로운 범위 설정',
      icon1: IconZoneGray,
      sub2: '여러 구역 설정',
      icon2: IconTagGray,
      image: image8,
    },
    {
      title: '모든 알림 이력을 통합 관리',
      desc: '신고 완료, 신고 취소, 테스트 신고, 배터리 부족, 교체 요청 등 모든 상태 변화가 앱 알림으로 누적 기록됩니다. 운영자는 알림 히스토리를 기반으로 점검, 교체, 응답 등의 후속 조치를 체계적으로 진행할 수 있습니다.',
      sub1: '자유로운 범위 설정',
      icon1: IconZoneGray,
      sub2: '여러 구역 설정',
      icon2: IconTagGray,
      image: image9,
    },
    {
      title: '안심벨 펌웨어 원격 업데이트',
      desc: '운영자는 모바일 앱을 통해 기기의 펌웨어를 최신 버전으로 업데이트할 수 있습니다. 추가 장비나 복잡한 과정 없이 안정적인 기능 개선이 가능해, 유지관리 효율이 크게 향상됩니다.',
      sub1: '자유로운 범위 설정',
      icon1: IconZoneGray,
      sub2: '여러 구역 설정',
      icon2: IconTagGray,
      image: image10,
    },
  ],

  customer: {
    title: '수많은 고객이 ORBRO를 선택한 이유, 그들의 이야기를 소개합니다.',
    card: [
      {
        logo: customer1,
        desc: '실제 설치 이후, 어디서 누가 어떻게 사용하고 있는지를 실시간으로 볼 수 있다는 점이 가장 큽니다. 단순히 보급해서 끝나는 게 아니라, 데이터를 기반으로 어떤 지역을 다음에 강화해야 할지까지 판단할 수 있습니다.',
        name: '정O용 본부장<br/>경기도청',
      },
    ],
  },
  subfunc: {
    title: '기능 요약',
    desc: '작업자의 안전을 보장하는 것은 효율성을 높이고 사고로 인한 손실을 줄입니다. 오브로는 건설 현장 작업자의 안전을 지키기 위해서 최적의 기능들을 구성하였습니다. 작업자가 위험 지역에 다가거나 사고가 발생했을 때, 또는 중장비가 가진 잠재적 위험상황을 포함하여 발생할 수 있는 안전사고에 적절히 대응하도록 시스템을 구축하였습니다.',

    data: [
      {
        icon: IconWarning, // 신고 연동 → 경고 및 긴급 호출
        title: '즉시 신고 연동 기능',
        desc: '버튼을 누르면 112에 자동 연결되고 보호자와 담당자에게 동시에 긴급 알림이 발송됩니다.',
      },
      {
        icon: IconSearch, // 연결 테스트 → 테스트/탐색 의미
        title: '연결 테스트 기능 내장',
        desc: '장비에 테스트 버튼이 있어 작동 여부를 상시 점검할 수 있습니다.',
      },
      {
        icon: IconLayers, // 수신 대상 다중 설정 → 구성/계층 의미
        title: '신고 수신 대상 다중 설정',
        desc: '보호자, 지자체, 112 등 원하는 수신 대상에게 동시에 알림을 보낼 수 있습니다.',
      },
      {
        icon: IconCar, // 저전력 운영 → 에너지 관련 기능이 없으므로 Car 임시 활용
        title: '10년 이상 저전력 운영',
        desc: '저전력 설계로 배터리 교체 없이 10년 이상 사용할 수 있습니다.',
      },
      {
        icon: IconRoute, // 앱 기반 알림 관리 → 흐름 및 관리
        title: '앱 기반 운영 및 알림 관리',
        desc: '신고 접수, 취소, 히스토리를 앱에서 실시간 확인하고 관리할 수 있습니다.',
      },
      {
        icon: IconAnalytics, // 알림 이력 관리 → 정량 분석
        title: '알림 이력 통합 관리',
        desc: '신고, 취소, 테스트, 배터리 경고 등의 모든 이력이 저장되어 편리한 관리가 가능합니다.',
      },
      {
        icon: IconSearch, // 펌웨어 업데이트 → 설정/제어 의미
        title: '펌웨어 원격 업데이트',
        desc: '모바일 앱을 통해 기기의 펌웨어를 원격으로 업데이트할 수 있습니다.',
      },
      {
        icon: IconLayers, // 설치 유연성 → 다양한 설치 공간 의미
        title: '설치 위치 유연성 확보',
        desc: '벽면이나 기둥 등 다양한 공간에 배선 없이 설치할 수 있어 도시 전역에 적용 가능합니다.',
      },
    ],
  },

  system: {
    title: '시스템 구성',
    img: rtlsSystem,
  },

  productTitle: '제품 구성',
  product: [
    {
      tag: 'workerPackage',
    },
    {
      tag: 'assetPackage',
    },
  ],

  contents: [
    {
      data: 'constructionAsset',
    },
    {
      data: 'constructionEquipment',
    },
    {
      data: 'blogRTLS',
    },
    {
      data: 'blogMedical',
    },
  ],
};
